import { FC } from "react";
import DocumentTable from "@/components/tables/simpleTableViews/documentTable";

interface Props {
  subjectId?: any;
  subjectForDispatch?: any;
  openWithSpecificSubjectIdUrl?: boolean;
}

const SubjectOverviewDocuments: FC<Props> = ({
  subjectId,
  subjectForDispatch,
  openWithSpecificSubjectIdUrl = false,
}) => {
  return (
    <>
      <DocumentTable
        customPageSize={5}
        folder="all"
        subjectId={subjectId}
        customDensity="compact"
        tableMargin={"0"}
        buttonLinkToDocuments={true}
        tableBoxShadow={"none"}
        openWithSpecificSubjectIdUrl={openWithSpecificSubjectIdUrl}
        subjectForDispatch={
          openWithSpecificSubjectIdUrl ? undefined : subjectForDispatch
        }
      />
    </>
  );
};

export default SubjectOverviewDocuments;
